import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';
import { GetRulesResponse } from '@hud/rules-dtos/api-rules.dtos';
export const RULES_ID = 'rules';

export default function useRules() {
  const { client, isReady } = useClient('detection');
  return useQuery({
    queryKey: [RULES_ID],
    queryFn: async () => {
      const response = await client.get<GetRulesResponse>('/rules');
      return GetRulesResponse.parse(response.data);
    },
    enabled: isReady,
  });
}
